import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { govtIntakeModuleExistingSystems } from '@/data/govtIntakeStaticData';
import { getPublicSystemCatalogList } from '@/modules/governmentIntake/api/shared';

export type PublicSystemCatalogOption = {
  id: string;
  name: string;
  vendor?: string;
};

const fallbackOptions: PublicSystemCatalogOption[] = govtIntakeModuleExistingSystems.map((item) => ({
  id: item.id,
  name: item.name,
  vendor: item.vendor ?? undefined,
}));

export function usePublicSystemCatalog() {
  const query = useQuery({
    queryKey: ['government-intake', 'public', 'system-catalog'],
    queryFn: () => getPublicSystemCatalogList({ isActive: true }),
  });

  const apiOptions = useMemo<PublicSystemCatalogOption[]>(() => {
    const rows = query.data?.data;
    if (!Array.isArray(rows)) {
      return [];
    }

    return rows
      .filter((row) => row && typeof row.id === 'number' && typeof row.name === 'string')
      .map((row) => ({
        id: String(row.id),
        name: row.name,
        vendor: row.vendor ?? undefined,
      }));
  }, [query.data]);

  const options = apiOptions.length > 0 ? apiOptions : fallbackOptions;

  return {
    options,
    isUsingFallback: apiOptions.length === 0,
    isLoading: query.isLoading,
    error: query.error,
  };
}
